"use client";

import { WalletAddress } from "@/components/core/WalletAddress/WalletAddress";
import { StarRating } from "@/components/ui/star-rating";
import { useDateFormatter } from "@/lib/i18n/date";

interface ReviewCardProps {
  rating: number;
  title: string | null;
  body: string | null;
  createdAt: string;
  author: { nickname: string | null; wallet_address: string } | null;
}

export const ReviewCard: React.FC<ReviewCardProps> = ({
  rating,
  title,
  body,
  createdAt,
  author,
}) => {
  const df = useDateFormatter();
  return (
    <div className="border-b last:border-b-0 border-stroke-light py-4 space-y-2">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm font-semibold text-text-primary">
          {author?.nickname ? (
            author.nickname
          ) : (
            <WalletAddress
              address={author?.wallet_address ?? ""}
              size={4}
              canCopy={false}
            />
          )}
        </span>
        <StarRating value={rating} readonly size="sm" />
      </div>
      {title && (
        <p className="text-sm font-medium text-text-primary">{title}</p>
      )}
      {body && <p className="text-sm text-text-secondary">{body}</p>}
      <p className="text-xs text-text-secondary">{df.numeric(createdAt)}</p>
    </div>
  );
};
